import { render, staticRenderFns } from "./UsersConfiguration.vue?vue&type=template&id=b8e2a998&"
import script from "./UsersConfiguration.vue?vue&type=script&lang=js&"
export * from "./UsersConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports